import {
  CardDetectionMode,
  CardOcrSDK,
  DisplayOrientation,
  SdkOptionsType,
  TransactionMode,
} from "@identy/identy-ocr";
import { S3FileUploaderService } from "./s3FileUploader";
import { IContextMenuSelection } from "./sdk-config.interface";

interface ICardType {
  name: string;
}

const s3Upload = new S3FileUploaderService();

const makeid = function (length: any) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    // tslint:disable-next-line:one-variable-per-declaration no-bitwise
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function postData(sdk: CardOcrSDK, capresult: any) {
  return new Promise((resolve, reject) => {
    return resolve(capresult);
  });
}

export function runCaptureOCR(
  transaction: TransactionMode,
  contextMenuSelection: IContextMenuSelection,
  selectAsFile: boolean,
) {
  return new Promise((resolve, reject) => {
    //this.started = contextMenuSelection.selection.fileSelection;
    let uuid = 1;
    let group = makeid(5);

    const options: SdkOptionsType = {
      allowClose: true,
      detectionModes: [],
      displayMode: DisplayOrientation.LANDSCAPE,
      a4IntegrityCheck: false,
      cardtype: contextMenuSelection.card_type,
      transaction: {
        type: transaction,
      },
      useFlash: contextMenuSelection.useFlash,

      events: {
        onBatteryLow: () => {
          alert("Battery low, Capture quality may suffer without flash. Please charge your phone.");
        },
        onNoDataDetected: () => {
          alert("No data detected, retry again. EXITING");
        },
        onCaptureStarted: (face: any) => {
          if (face === "BACK" && !contextMenuSelection.fileSelection) {
            alert("Capture back of the document.");
          }
        },
        onCaptured: (image: string, face: string) => {
          s3Upload.addUploadObject({
            file: `frame_${group}_${uuid}_${new Date().getTime()}.jpg`,
            type: "IMAGE",
            face: face,
            data: image,
            bucket: "image-identy-web",
            modality: "OCR",
            ts: new Date().getTime(),
          });
        },
        onRecognition: (image: string, face: string, data?: any) => {
          console.log("onRecognition", image, data);
          const ts = new Date().getTime();
          s3Upload.addUploadObject({
            file: `frame_recog_${group}_${uuid}_${ts}.jpg`,
            type: "IMAGE",
            face: face,
            data: image,
            bucket: "image-identy-web",
            modality: "OCR",
            ts: new Date().getTime(),
          });
          if (data) {
            if (options.cardtype) {
              s3Upload.addUploadObject({
                file: `frame_recog_data_${
                  options.cardtype.isA4 ? "a4" : "card"
                }_${group}_${uuid}_${ts}.txt`,
                type: "TEXT",
                face: "FRONT",
                data: JSON.stringify(data),
                bucket: "image-identy-web",
                modality: "OCR",
                ts: new Date().getTime(),
              });
            }
          }
        },
        onA4CropComplete: (full: string, cropped: string, bounds: any, actual_bounds: any) => {
          s3Upload.addUploadObject({
            file: `frame_A4_FULL_${group}_${uuid}_${new Date().getTime()}.jpg`,
            type: "IMAGE",
            face: "FRONT",
            data: full,
            bucket: "image-identy-web",
            modality: "OCR",
            ts: new Date().getTime(),
          });
          s3Upload.addUploadObject({
            file: `frame_A4_CROPPED_${group}_${uuid}_${new Date().getTime()}.jpg`,
            type: "IMAGE",
            face: "FRONT",
            data: cropped,
            bucket: "image-identy-web",
            modality: "OCR",
            ts: new Date().getTime(),
          });
          s3Upload.addUploadObject({
            file: `frame_A4_BOUNDS_corrected_${group}_${uuid}_${new Date().getTime()}.txt`,
            type: "TEXT",
            face: "FRONT",
            data: JSON.stringify(bounds),
            bucket: "image-identy-web",
            modality: "OCR",
            ts: new Date().getTime(),
          });
          s3Upload.addUploadObject({
            file: `frame_A4_ACTUAL_BOUNDS_corrected_${group}_${uuid}_${new Date().getTime()}.txt`,
            type: "TEXT",
            face: "FRONT",
            data: JSON.stringify(actual_bounds),
            bucket: "image-identy-web",
            modality: "OCR",
            ts: new Date().getTime(),
          });
        },
        onAttempt: (attempt: any) => {
          uuid = attempt;
        },
        onCrash: (image: any) => {
          console.log("Adding crash", image);
          s3Upload.addUploadObject({
            file: `frame_A4_CRASHED_${group}_${uuid}_${new Date().getTime()}.jpg`,
            type: "IMAGE",
            face: "FRONT",
            data: image,
            bucket: "image-identy-web",
            modality: "OCR",
            ts: new Date().getTime(),
          });
        },
        onVerifyFrame: (image: any) => {
          console.log("Adding verify", image);
          s3Upload.addUploadObject({
            file: `frame_A4_VERIFY_${group}_${uuid}_${new Date().getTime()}.jpg`,
            type: "IMAGE",
            face: "FRONT",
            data: image,
            bucket: "image-identy-web",
            modality: "OCR",
            ts: new Date().getTime(),
          });
        },
      },
      debug: true,
      selectAsFile: true,
    };

    const cardOcrSDK = new CardOcrSDK(options);
    cardOcrSDK.onInit = () => {
      // @ts-ignore
      cardOcrSDK
        .capture()
        .then(async (blob: any) => {
          return resolve(postData(cardOcrSDK, blob));
        })
        .catch((err) => {
          s3Upload.upload_frames().then(() => {
            console.log("Frames uploaded....");
          });
          if (err && err["code"] && err["code"] === 811) {
            alert("Native crash");
          }
          return reject(err);
        });
    };

    cardOcrSDK.initialize().catch((err) => {
      const m = err && err["getLocalizedString"];
      if (m) {
        if (err.code === 100 || err.code === 104 || err.code === 500) {
          alert(err.getLocalizedString());
          reject(err);
        }

        if (err.code === 600 || err.code == 506) {
          const clientResponse = { code: err.code, feedback_code: err.message, spoof: null };
        }
      } else {
        reject(err);
      }
    });
  });
}

const format = function date2str(x: any, y: any) {
  var z: any = {
    M: x.getMonth() + 1,
    d: x.getDate(),
    h: x.getHours(),
    m: x.getMinutes(),
    s: x.getSeconds(),
  };
  y = y.replace(/(M+|d+|h+|m+|s+)/g, function (v: any) {
    return ((v.length > 1 ? "0" : "") + z[v.slice(-1)]).slice(-2);
  });

  return y.replace(/(y+)/g, function (v: any) {
    return x.getFullYear().toString().slice(-v.length);
  });
};

function capture(contextMenuSelection: IContextMenuSelection, selectAsFile: boolean) {
  return new Promise((resolve, reject) => {
    runCaptureOCR(TransactionMode.CAPTURE, contextMenuSelection, selectAsFile)
      .then((response: any) => {
        const out = response.data;
        if (out && response.code === 200) {
          return resolve({
            ocr_output: response.data,
          });
        }
      })
      .catch((err) => {
        return reject(err);
      });
  });
}
